import { OutsideEnrollmentAreaStatus } from "../models/Request";
import {
  OUTSIDE_ENROLLMENT_AREA_DECISION_STATUSES,
  OUTSIDE_ENROLLMENT_AREA_SUGGESTED_ENROLLMENT_STATUSES,
} from "../features/Request/constants";

export const isStatusSuggestedEnrollment = (
  status: OutsideEnrollmentAreaStatus | null
) => {
  if (!status) return false;

  return OUTSIDE_ENROLLMENT_AREA_SUGGESTED_ENROLLMENT_STATUSES.includes(status);
};

export const isStatusOutsideEnrollmentAreaDecision = (
  status: OutsideEnrollmentAreaStatus | null
) => {
  if (!status) return false;

  return OUTSIDE_ENROLLMENT_AREA_DECISION_STATUSES.includes(status);
};

export const isStatusDecisionSuggestedEnrollment = (
  status: OutsideEnrollmentAreaStatus | null
) => {
  if (!status) return false;

  return [
    ...OUTSIDE_ENROLLMENT_AREA_SUGGESTED_ENROLLMENT_STATUSES,
    ...OUTSIDE_ENROLLMENT_AREA_DECISION_STATUSES,
  ].includes(status);
};

export const isStatusOutsideEnrollmentAreaProcessed = (
  status: OutsideEnrollmentAreaStatus | null
) => {
  if (!status) return false;

  return (
    status !== OutsideEnrollmentAreaStatus.NotProcessed &&
    isStatusDecisionSuggestedEnrollment(status)
  );
};
